import createWidgetFactory from 'components-framework/widget/create_widget_factory';
import Model from './model';
import View from './view';

const factory = createWidgetFactory({
    name: 'block_expiring_cards',
    viewClass: View,
    modelClass: Model,

    methods: {
        checkExpiringCard(value) {
            this.model.set(value);
        },
        scrollToWarningMessage() {
            this.scrollToWarningMessage();
        },
    },
});

export default factory;
